import { BlurView } from 'expo-blur'
import React from 'react'
import { Image, StyleSheet } from 'react-native'

import { DS } from '../../design-system'
import { LearnPoker } from './LearnPoker'

export const LiveEventBoard = ({
  eventName,
  userFirstName,
  handleOpenCheatSheet
}: {
  eventName: string
  userFirstName: string
  handleOpenCheatSheet: () => void
}) => {
  return (
    <BlurView intensity={80} tint="light" style={styles.container}>
      <DS.Frame bg="Global/White" style={styles.frameContainer}>
        <Image source={require('./assets/live-badge.png')} style={styles.liveBadge} />
        <DS.Text variant="Heading 3/Medium" color="Global/Black" textAlign="center" style={{ marginTop: 15 }}>
          {`Welcome to the ${eventName} event ${userFirstName}!`}
        </DS.Text>
        <DS.Frame style={{ marginTop: DS.spacing[16] }}>
          <LearnPoker customTitle={'View Cheatsheet'} handleOpenCheatSheet={handleOpenCheatSheet} />
        </DS.Frame>
      </DS.Frame>
    </BlurView>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: DS.spacing[16],
    backgroundColor: 'rgba(255, 255, 255, 0.50)',
    borderRadius: 12,
    overflow: 'hidden'
  },
  frameContainer: {
    padding: DS.spacing[16],
    borderRadius: 12
  },
  liveBadge: {
    alignSelf: 'center',
    width: 40,
    height: 40
  }
})
